import { render, staticRenderFns } from "./newviewsdetail.vue?vue&type=template&id=ff527164&scoped=true&"
import script from "./newviewsdetail.vue?vue&type=script&lang=js&"
export * from "./newviewsdetail.vue?vue&type=script&lang=js&"
import style0 from "./newviewsdetail.vue?vue&type=style&index=0&id=ff527164&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff527164",
  null
  
)

export default component.exports